<div class="long-title">
    <h4 class="content-block ap-green">Marketing Insight (MI)/Multi-Variable Analysis (MVA) Upload</h4>
</div>

<div id="form-container">
    <form (submit)="handleSubmit($event)">

        <div class="form-group row">
            <label for="inputEmail3" class="col-md-1 label-text required">Type</label>
            <div class="col-md-4">
                <dx-select-box [dataSource]="types" placeholder="Choose" [showClearButton]="true"
                    displayExpr="text" valueExpr="value" [searchEnabled]="true" [(value)]="selectedType">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Please select the type">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
        </div>

        <div class="form-group row" *ngIf="selectedType == 'mva'">
            <label for="inputEmail3" class="col-md-1 label-text required">Country</label>
            <div class="col-md-4">
                <dx-tag-box [dataSource]="countriesDataSource" [showSelectionControls]="true" displayExpr="countryName"
                    valueExpr="countryId" [(value)]="selectedCountries">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Country selection is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

        <div class="form-group row" *ngIf="selectedType == 'mva'">
            <label for="inputEmail3" class="col-md-1 label-text required">Product</label>
            <div class="col-md-4">
                <dx-tag-box [items]="products" [showSelectionControls]="true" displayExpr="" valueExpr=""
                    [(value)]="selectedProducts">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Product is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

        <div class="form-group row" *ngIf="selectedType">
            <label for="inputEmail3" class="col-md-1 label-text required">Company File</label>
            <div class="col-md-2">
                <dx-file-uploader name="companyFileAttachment" labelText="" [(value)]="companyFileAttachment"
                    [multiple]="false" (onValueChanged)="readCompanyFile($event)" uploadMode="useForm" selectButtonText="Attach File">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Company File is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-file-uploader>
            </div>
        </div>

        <div class="form-group row" *ngIf="selectedType == 'mva'">
            <label for="inputEmail3" class="col-md-1 label-text required">Product File</label>
            <div class="col-md-2">
                <dx-file-uploader name="prodVolumeFileAttachment" labelText="" [(value)]="prodVolumeFileAttachment"
                    [multiple]="false" (onValueChanged)="readProdVolumeFile($event)" uploadMode="useForm"
                    [maxFileSize]="4000000" selectButtonText="Attach File">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Product File is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-file-uploader>
            </div>
        </div>

        <div class="row">
            <div class="col-1" style="width:6.7%;">
                <dx-button icon="save" text="Save" type="success" [useSubmitBehavior]="true"></dx-button>&nbsp;
            </div>
        </div>
    </form>
</div>
<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>